import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Users from '../views/Users.vue'
import Settings from '../views/Settings.vue'
import Products from '../views/Products.vue'
import VipProducts from '../views/VipProducts.vue'
import PledgeOrders from '../views/orders/PledgeOrders.vue'
import WithdrawOrders from '../views/orders/WithdrawOrders.vue'
import DepositOrders from '../views/orders/DepositOrders.vue'
import Layout from '../components/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'users',
        name: 'Users',
        component: Users
      },
      {
        path: 'products',
        name: 'Products',
        component: Products
      },
      {
        path: 'vip-products',
        name: 'VipProducts',
        component: VipProducts
      },
      {
        path: 'orders/pledge',
        name: 'PledgeOrders',
        component: PledgeOrders
      },
      {
        path: 'orders/withdraw',
        name: 'WithdrawOrders',
        component: WithdrawOrders
      },
      {
        path: 'orders/deposit',
        name: 'DepositOrders',
        component: DepositOrders
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  if (to.path !== '/login' && !token) {
    // 如果不是登录页面且没有token，重定向到登录页
    next('/login')
  } else {
    next()
  }
})

export default router 